// extracted by mini-css-extract-plugin
export default {"indicator-bar":"Ylph6iG","indicator-bar__progress":"jNduS2F","indicator-bar__triangle":"y0EKMvF"};